import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const user = await googleLogin(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate("/admin/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <div className="w-8 h-8 border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin" />
      <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-zinc-500">Signing you in...</p>
    </div>
  );
}
